/**
 * Services Element Colors — default color per mappable element type
 *
 * @module core/modules/services/constants/element-colors
 *
 * @description
 * Colores por defecto para los 6 tipos de elementos del módulo de servicios
 * que se representan en el mapa. El usuario puede personalizar cada color
 * desde el panel.
 */

/** The 6 services element types that have map representation */
export type ServicesElementId =
  | 'water'
  | 'sewage'
  | 'electricity'
  | 'gas'
  | 'telecom'
  | 'meters';

export const SERVICES_ELEMENT_COLORS: Record<ServicesElementId, string> = {
  'water':       '#06b6d4', // cyan (agua)
  'sewage':      '#78716c', // stone (cloacas)
  'electricity': '#fbbf24', // amarillo (electricidad)
  'gas':         '#f97316', // naranja (gas)
  'telecom':     '#8b5cf6', // violeta (telecomunicaciones)
  'meters':      '#64748b', // gris (medidores)
};

/** Set of IDs for quick lookup */
export const MAPPABLE_ELEMENT_IDS = new Set<string>(
  Object.keys(SERVICES_ELEMENT_COLORS),
);
